import {inject, Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {UserService} from '../services/user.service';

@Injectable({providedIn: 'root'})
export class SignGuard implements CanActivate {
  private _auth = inject(AuthService);
  private _router = inject(Router);

  canActivate(): boolean {
    if (this._auth.getToken()) {
      this._router.navigate(['/dashboard']);
      return false;
    }
    return true;
  }
}
